import { CardMedia, Grid } from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/system";
import React from "react";
import { useNavigate } from "react-router-dom";
import { handleLocalize } from "../../utils/helper";
import moment from "moment";
import CustomButton from "../../UiComponent/CustomButton";

export default function BlogsComponent(props: any) {
  const navigate = useNavigate();
  const theme = useTheme();
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  // const [state, setState] = React.useReducer(
  //   (state: any, newState: any) => ({ ...state, ...newState }),
  //   {
  //     activity: false,
  //     page: 1,
  //     allBlogs: props?.allBlogs,
  //   }
  // );
  return (
    <Grid container spacing={3}>
      {props?.allBlogs?.slice(0, 3)?.map((item: any) => {
        return (
          <>
            <Grid
              item
              xs={12}
              sm={6}
              md={screen_1024 ? 4 : 6}
              // className="cards__item"
              style={{
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/blog-details/${item?.blog_cat_id}/${item?.id}`);
              }}
            >
              <div className="card">
                <CardMedia
                  component="img"
                  style={{
                    minHeight: screen_1024 ? 296 : 220,
                    objectFit: "cover",
                    borderRadius: 8,
                  }}
                  image={item?.blog_image?.[1] ?? item?.blog_image?.[0]} // Replace with the image URL you need
                  alt="Blog card image"
                />
                <div className="card__content" style={{ gap: 10 }}>
                  <div style={{ display: "flex" }}>
                    <div className="card__title" style={{ flex: 1 }}>
                      {handleLocalize(item?.title)}
                    </div>
                  </div>
                  <p
                    className="card__text"
                    style={{
                      margin: 0,
                      maxLines: 4,
                      display: screen_1024 ? "block" : "none",
                    }}
                  >
                    {handleLocalize(item?.sub_title)}
                  </p>
                  <p
                    style={{
                      fontSize: screen_1024 ? "16px" : "12px",

                      color: "#78778A",
                      fontWeight: "400",
                      margin: 0,
                    }}
                    className="montserrat-Regular"
                  >
                    {moment(
                      `${item?.created_at}`.endsWith("Z")
                        ? item?.created_at
                        : item?.created_at + "Z"
                    ).format("DD MMMM YYYY")}{" "}
                    <span
                      style={{
                        fontFamily: "montserrat-SemiBold",
                        textDecoration: "underline",
                        color: "#000",
                        paddingLeft: 5,
                        display: screen_1024 ? "block" : "none",
                      }}
                    >
                      {handleLocalize(item?.category_name)}
                    </span>
                  </p>
                  <div
                    style={{
                      display: screen_1024 ? "block" : "none",
                    }}
                  >
                    <CustomButton
                      style={{
                        padding: "9px 21px",
                      }}
                      onClick={() => {
                        // navigate("/transporter-un-colis");
                        navigate(
                          `/blog-details/${item?.blog_cat_id}/${item?.id}`
                        );
                      }}
                      classesNames={"new_contained_button"}
                      value={"En savoir plus"}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </>
        );
      })}
    </Grid>
  );
}
